
import { Modal } from "../ui/components/Modal";
import api from "../api";

export class RenameFolderModal extends Modal {

    init() {
        super.init();

        this.cancelBtn?.on('click', () => {
            this.hide();
        });

        this.input.on('keyup', this.onInputChange.bind(this));
        this.input.on('change', this.onInputChange.bind(this));

        this.submitBtn.on('click', this.onSubmit.bind(this));
    }

    show() {
        this.input.value(this.val);
        this.submitBtn.disable();
        super.show();
    }

    onInputChange(e) {
        if (e?.keyCode === 13) {
            // Enter
            this.onSubmit();
            return;
        }

        if (this.input.element.value.length > 0) {
            this.submitBtn.enable();
        } else {
            this.submitBtn.disable();
        }
    }

    async onSubmit() {
        const name = this.input.value();
        try {
            const response = await api.post("/api/folders/" + this.id, { name, redirect: true });

        } catch (error) {
            this.errorBag.show(error);
            return;
        }
    }


}
